import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";
import { formats } from "../../config/constants";

const TESCOXMLInputModel = {
  uploadXMLFileTESCO: (payload) => {
    let body = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      body.append(key, value)
    })

    const filename = payload.uploadXml.name || 'test';

    return modelBaseV2.post('/api/datainput/tesco/uploadvalidate', { body }, filename);
  },
  
  downloadResultFile: (fileId, fileName) => {
    modelBaseV2.getDownload('/api/file/temp/:fileId', { params: { fileId } }, `${fileName}_${moment().format(formats.apiDateFormat)}`)
  }
}

export default TESCOXMLInputModel;